export const draggableSignatureButtonTestIds = {
  button: 'add-signature-button',
};
